import React, { FC, useState } from "react";
import { Card } from "antd";
import { Maybe } from "graphql/jsutils/Maybe";
import {
  Patientportal_AppointmentRequestProxyMsg,
  Resource_AppointmentSlotProposalMsg,
} from "../../src/generated/graphql";
import { useIntl } from "react-intl";
import Title from "antd/lib/typography/Title";
import styles from "./appointment-request.module.scss";
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
import {
  buildTimestampDate,
  buildTimestampTime,
} from "../../helpers/formatters";
import { AcceptAppointmentProposalModal } from "./accept-appointment-proposal-modal";
import { AveliosButton } from "../common-layout/avelios-button";
import { RejectAppointmentProposalsModal } from "./reject-appointment-proposals-modal";

interface AppointmentRequestProposalsProps {
  appointmentRequestProxy:
    | Maybe<Patientportal_AppointmentRequestProxyMsg>
    | undefined;
}

export const AppointmentRequestProposals: FC<
  AppointmentRequestProposalsProps
> = ({ appointmentRequestProxy }) => {
  const { formatMessage } = useIntl();

  const appointmentSlotProposals =
    appointmentRequestProxy?.appointmentRequest?.appointmentSlotProposals;

  const [acceptModalOpen, setAcceptModalOpen] = useState<boolean>(false);
  const [rejectModalOpen, setRejectModalOpen] = useState<boolean>(false);
  const [selectedAppointmentSlotProposal, setSelectedAppointmentSlotProposal] =
    useState<Maybe<Resource_AppointmentSlotProposalMsg> | undefined>();

  return appointmentSlotProposals && appointmentSlotProposals.length > 0 ? (
    <Card>
      <Title level={3} style={{ fontWeight: "bold" }}>
        {formatMessage({ id: "appointment.proposal" })}
      </Title>
      <p className={styles.description}>
        {formatMessage({ id: "appointment.proposal.description" })}
      </p>
      <div>
        {appointmentSlotProposals.map((appointmentSlotProposal) => (
          <div
            key={appointmentSlotProposal?.id}
            className={styles.appointment}
            onClick={() => {
              setSelectedAppointmentSlotProposal(appointmentSlotProposal);
              setAcceptModalOpen(true);
            }}
          >
            <span>
              <CalendarOutlined />{" "}
              {buildTimestampDate(appointmentSlotProposal?.startTime)}
            </span>
            <span className={styles.appointmentTime} style={{ marginLeft: 20 }}>
              <ClockCircleOutlined />{" "}
              {buildTimestampTime(appointmentSlotProposal?.startTime)}
            </span>
          </div>
        ))}
      </div>
      <AveliosButton
        type={"text"}
        block
        danger
        onClick={() => setRejectModalOpen(true)}
      >
        {formatMessage({ id: "appointment.proposal.reject-all" })}
      </AveliosButton>
      <RejectAppointmentProposalsModal
        clinicId={appointmentRequestProxy?.clinicId}
        appointmentRequestId={appointmentRequestProxy?.appointmentRequest?.id}
        open={rejectModalOpen}
        onClose={() => setRejectModalOpen(false)}
      />
      <AcceptAppointmentProposalModal
        clinicId={appointmentRequestProxy?.clinicId}
        appointmentSlotProposal={selectedAppointmentSlotProposal}
        open={acceptModalOpen}
        onClose={() => {
          setAcceptModalOpen(false);
          setSelectedAppointmentSlotProposal(null);
        }}
      />
    </Card>
  ) : null;
};
